import { render, staticRenderFns } from "./DegreesUpdate.vue?vue&type=template&id=1b5722e0"
import script from "./DegreesUpdate.vue?vue&type=script&lang=js"
export * from "./DegreesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports